function createMemoryStorage() {
  const store = new Map()

  return {
    get length() {
      return store.size
    },
    clear() {
      store.clear()
    },
    getItem(key) {
      const normalizedKey = String(key)
      return store.has(normalizedKey) ? store.get(normalizedKey) : null
    },
    key(index) {
      const keys = Array.from(store.keys())
      return keys[index] || null
    },
    removeItem(key) {
      store.delete(String(key))
    },
    setItem(key, value) {
      store.set(String(key), String(value))
    },
  }
}

function patchStorageProperty(propertyName) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const storage = window[propertyName]
    if (!storage) {
      throw new Error('storage is unavailable')
    }
  } catch (error) {
    const fallbackStorage = createMemoryStorage()
    try {
      Object.defineProperty(window, propertyName, {
        value: fallbackStorage,
        configurable: true,
      })
    } catch (defineError) {
      // If redefining fails, keep app running without throwing.
    }
  }
}

patchStorageProperty('localStorage')
patchStorageProperty('sessionStorage')
